import React, { Component } from "react";
import { Button, Input, Form, Table, Select, DatePicker, Radio, message } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import StoreAPI from '@/api/store';
import utils from '@/utils/auth';
const { RangePicker } = DatePicker;
const Container = styled.div`
  .search-wrapper {
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .ant-form-item {
      margin-bottom: 15px;
    }
  }
`;

class ReservationData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        kdtId: '',
        orderNo: '',
        mtOrderId: '',
        reservationNo: '',
        mobile: '',
        reservationStatus: '',
        finishStartTime: '',
        finishEndTime: '',
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataList: [],
      reservationStatusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '待服务',
          value: 0
        },
        {
          label: '已完成',
          value: 1
        },
        {
          label: '已取消',
          value: 2
        }
      ],
      storeList: [],
      pickerType: 'date',
    };
  }

  componentDidMount() {
    this.initPage();
    this.initStoreList();
  }

  initPage = () => {
    const { searchParams } = this.state;
    StoreAPI.queryStoreReservationData(searchParams)
      .then(({ items: dataList, paginator }) => {
        const { totalCount: total } = paginator;
        this.setState({ dataList, total });
      });
  }

  initStoreList = () => {
    StoreAPI.queryYzStoreList()
      .then(storeList => {
        this.setState({ storeList: [{ kdtName: '全部', kdtId: '' }, ...storeList] });
      });
  }

  onSearch = () => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: 1 }) }, this.initPage);
  }

  onPageChange = (current, pageSize) => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: current, pageSize }) }, this.initPage);
  }

  onPickerTypeChange = e => {
    const value = e.target.value;
    this.setState({ pickerType: value });
  }

  onFinishDateChange = (dates, [startTime, endTime]) => {
    const { searchParams, pickerType } = this.state;
    if (pickerType === 'month' && startTime && endTime) {
      const finishStartTime = moment(startTime, 'YYYY-MM').startOf('month').format("YYYY-MM-DD HH:mm:ss");
      const finishEndTime = moment(endTime, 'YYYY-MM').endOf('month').format("YYYY-MM-DD HH:mm:ss");
      this.setState({ searchParams: Object.assign(searchParams, { finishStartTime, finishEndTime }) });
    } else {
      this.setState({ searchParams: Object.assign(searchParams, { finishStartTime: startTime, finishEndTime: endTime }) });
    }
  }

  exportData = () => {
    const { searchParams } = this.state;
    StoreAPI.exportStoreReservationData(searchParams)
        .then(response => {
          const contentType = response.headers.get('content-type');
          if (contentType.includes('application/json')) {
            const { data: body } = response;
            const file = new FileReader();
            file.readAsText(body, 'utf-8');
            file.onload = function () {
              const obj = JSON.parse(file.result);
              const { code, message: msg = '未知错误' } = obj;
              if (code !== 200) message.warning(msg);
            }

          } else if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
            const { data: body } = response;
            const blob = new Blob([body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `美团预约数据-${moment().format('YYYYMMDDHHmmss')}.xlsx`); // 设置下载文件的名称

            document.body.appendChild(link);
            link.click();

            // 清理
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        });
  }

  clearSearchParams = () => {
    let { searchParams } = this.state;
    for (const key in searchParams) {
      if (key === 'kdtId') {
        searchParams[key] = null;
      } else if (!['pageNum', 'pageSize'].includes(key)) {
        searchParams[key] = '';
      }
    }

    this.setState({ searchParams: Object.assign({}, searchParams, { pageNum: 1, pageSize: 10 }) }, this.initPage);
  }

  isEmptyObject = obj => {
    return Object.values(obj).every(value => {
      // 检查值是否为空
      return value == null || value === '';
    });
  }

  render() {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);
    const { searchParams, dataList, total, pickerType, reservationStatusOptions, storeList } = this.state;
    const columns = [
      {
        title: '有赞店铺名称',
        dataIndex: 'kdtName',
        key: 'kdtName'
      },
      {
        title: '美团店铺名称',
        dataIndex: 'mtShopName',
        key: 'mtShopName'
      },
      {
        title: '有赞预约单号',
        dataIndex: 'reservationNo',
        key: 'reservationNo'
      },
      {
        title: '有赞订单号',
        dataIndex: 'orderNo',
        key: 'orderNo'
      },
      {
        title: '美团订单号',
        dataIndex: 'mtOrderId',
        key: 'mtOrderId'
      },
      {
        title: '预约状态',
        render: ({ reservationStatus }) => {
          const { label = '' } = reservationStatusOptions.find(o => o.value === reservationStatus) || {};
          return label;
        }
      },
      {
        title: '客户名称',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: '性别',
        render: ({ gender }) => ['其他', '男', '女'][gender]
      },
      {
        title: '手机号',
        dataIndex: 'mobile',
        key: 'mobile'
      },
      {
        title: '商品信息',
        render: ({ items }) => items.map((o, index) => <p key={index}>{o.itemName}</p>)
      },
      {
        title: '商品单价(元)/数量',
        render: ({ items }) => items.map((o, index) => <p key={index}>{o.amount.toFixed(2)} / {o.num}</p>)
      },
      {
        title: '订单金额(元)',
        render: ({ amount }) => amount.toFixed(2)
      },
      // {
      //   title: '优惠金额(元)',
      //   render: ({ discountAmount }) => discountAmount.toFixed(2)
      // },
      {
        title: '实付金额(元)',
        render: ({ paidAmount }) => paidAmount.toFixed(2)
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime'
      }
    ];

    return (
      <Container>
        <div className="search-wrapper">
          <Form layout="inline">
            <Form.Item label="有赞订单号">
              <Input
                allowClear
                value={searchParams.orderNo}
                placeholder="请输入有赞订单号"
                onChange={e => {
                  const value = e.target.value.trim();
                  this.setState({ searchParams: Object.assign(searchParams, { orderNo: value }) });
                }}
              />
            </Form.Item>
            <Form.Item label="美团订单号">
              <Input
                allowClear
                value={searchParams.mtOrderId}
                placeholder="请输入美团订单号"
                onChange={e => {
                  const value = e.target.value.trim();
                  this.setState({ searchParams: Object.assign(searchParams, { mtOrderId: value }) });
                }}
              />
            </Form.Item>
            <Form.Item label="有赞预约单号">
              <Input
                allowClear
                value={searchParams.reservationNo}
                placeholder="请输入有赞预约单号"
                onChange={e => {
                  const value = e.target.value.trim();
                  this.setState({ searchParams: Object.assign(searchParams, { reservationNo: value }) });
                }}
              />
            </Form.Item>
            <Form.Item label="客户手机号">
              <Input
                allowClear
                value={searchParams.mobile}
                placeholder="请输入客户手机号"
                onChange={e => {
                  const value = e.target.value.trim();
                  this.setState({ searchParams: Object.assign(searchParams, { mobile: value }) });
                }}
              />
            </Form.Item>
            <Form.Item label="预约状态">
              <Select
                style={{ width: 200 }}
                value={searchParams.reservationStatus}
                options={reservationStatusOptions}
                placeholder="请选择预约状态"
                onChange={value => {
                  this.setState({ searchParams: Object.assign(searchParams, { reservationStatus: value }) });
                }}
              />
            </Form.Item>
            <Form.Item label="完成时间">
              <RangePicker
                picker={pickerType}
                showTime
                onChange={this.onFinishDateChange}
              />
            </Form.Item>
            <Form.Item>
              <Radio.Group onChange={this.onPickerTypeChange} value={pickerType}>
                <Radio value="date">按日</Radio>
                <Radio value="month">按月</Radio>
              </Radio.Group>
            </Form.Item>
            {
              utils.isUserHeadQuarter() && <Form.Item label="服务门店">
                  <Select
                      allowClear
                      showSearch
                      style={{ width: 200 }}
                      value={searchParams.kdtId}
                      options={storeList}
                      placeholder="请选择门店"
                      optionFilterProp="kdtName"
                      fieldNames={{
                        label: 'kdtName',
                        value: 'kdtId'
                      }}
                      onChange={value => {
                        this.setState({ searchParams: Object.assign(searchParams, { kdtId: value || '' }) });
                      }}
                  />
              </Form.Item>
            }
            <Form.Item>
              <Button type="primary" onClick={this.onSearch}>查询</Button>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                disabled={this.isEmptyObject(Object.assign({}, searchParams, { pageNum: '', pageSize: '' }))}
                onClick={this.clearSearchParams}
              >
                重置
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                disabled={!status || this.isEmptyObject(Object.assign({}, searchParams, { pageNum: '', pageSize: '' }))}
                onClick={this.exportData}
              >
                导出
              </Button>
            </Form.Item>

          </Form>
        </div>

        <div className="content-wrapper">
          <Table
            rowKey="reservationNo"
            scroll={{
              x: 2400
            }}
            columns={columns}
            dataSource={dataList}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              total,
              showTotal: total => `共${total}条`,
              hideOnSinglePage: false,
              onChange: this.onPageChange
            }}
          />
        </div>
      </Container>
    );
  }
}


export default ReservationData;
